/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';
import axios from 'axios';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
export const useGravityValidationStore = defineStore('useGravityValidationStore', {
  state: () => {
    const {
      handleError
    } = useSnackbarHandler();
    return {
      handleError,
      confidoValidation: null
    };
  },
  actions: {
    async validateConfidoEnabled() {
      try {
        const {
          data
        } = await axios({
          url: '/me/company/validate'
        });
        this.confidoValidation = data.gravity;
      } catch (error) {
        this.handleError(error);
      }
    }
  }
});